import { render, staticRenderFns } from "./DealViewer.vue?vue&type=template&id=aa010650&scoped=true"
import script from "./DealViewer.vue?vue&type=script&lang=js"
export * from "./DealViewer.vue?vue&type=script&lang=js"
import style0 from "./DealViewer.vue?vue&type=style&index=0&id=aa010650&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa010650",
  null
  
)

export default component.exports